export default {
    shareButton: 'Compartilhar',
    chartButton: 'Mapa Gráfico',
    shareButtonAlt: 'Ícone compartilhar',
    chartButtonAlt: 'Ícone ver mapa gráfico',
    graphicChartAlt: 'Mapa astral gráfico',

    list: {
        title: 'Dicas para leitura de seu Mapa Astral:',

        readmore: 'Ler mais...',

        subtitle: {
            partial: 'Uma boa forma de começar a sua jornada astrológica é conhecendo a sua tríade',
            full: '<span>Uma boa forma de começar a sua jornada astrológica é conhecendo a sua tríade principal: <b>signo, ascendente</b> e <b>lua</b>! Estas são as informações básicas de sua personalidade.</span><span>Além disso, é importante conhecer os outros <b>posicionamentos dos astros</b> em seu mapa para que você aprenda mais sobre a sua forma de pensar, agir, se relacionar e muito mais.</span><span>Cada área da sua vida (saúde, amor, família, trabalho, expansão...) é representada pelas <b>casas astrológicas</b>. Compreender as energias que ali transitam também é super importante</span>.',
        },

        positions: {
            alt: 'Galáxia',
            title: 'Posição dos Astros',
            text: 'Conjunto astrológico que molda sua personalidade e diretrizes de vida'
        },

        distribution: {
            alt: 'Distribuição',
            title: 'Distribuição Energética',
            text: 'O equilíbrio dos 4 elementos, das qualidades fundamentais e o das suas energias Yin e Yang'
        },

        basics: {
            alt: 'Rosto feliz e rosto triste ',
            title: 'Características Básicas',
            text: 'Luz e Sombra da personalidade'
        },

        strengths: {
            alt: 'Gráfico de barras',
            title: 'A Força dos Signos no mapa',
            text: 'Quais signos atuam mais forte em seu mapa'
        },

        houses: {
            alt: 'Roda de casas astrológicas',
            title: 'As Casas Astrológicas',
            text: 'A interação astrológica nas suas área da vida: valores, família, carreira, relacionamentos, etc.'
        },

        aspects: {
            alt: 'Linha de conexão',
            title: 'Aspectos Planetários',
            text: 'A comunicação fluida ou tensa entre os planetas no seu mapa'
        },

        energys: {
            alt: 'Raio',
            title: 'Energias em destaque',
            text: 'Forças e potências que se destacam, separados por signos, casas e planetas'
        },

        charts: {
            alt: 'Roda astrológica',
            title: 'Mapas Gráficos',
            text: 'Gráfico de seu mapa de forma resumida ou esférico'
        },

        nextLevel: 'Passando para o próximo nível'
    },

    modal: {
        title: 'Destaques pessoais',
        text: 'Destacamos em nosso índice alguns tópicos que podem ser relevantes ao seu interesse.',
        button: 'Entendi'
    },
};